import { render, staticRenderFns } from "./PatentBulletinAnalyseReportForm.vue?vue&type=template&id=28f3f80d&"
import script from "./PatentBulletinAnalyseReportForm.vue?vue&type=script&lang=js&"
export * from "./PatentBulletinAnalyseReportForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentBulletinAnalyseReportForm.vue?vue&type=style&index=0&id=28f3f80d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports